<app-verify-email-page
  [verifyEmailWorking]="verifyEmailWorking$ | async"
  [verifyEmailSuccess]="verifyEmailSuccess$ | async"
  [verifyEmailError]="verifyEmailError$ | async"
  [accountValidationResult]="accountValidationResult$ | async">
</app-verify-email-page>
